import actionFe from 'utils/mw/actionFe.util';

const feSetThemeMode = actionFe('feSetThemeMode');

// noinspection JSUnusedGlobalSymbols
export default feSetThemeMode;
